import { combineReducers } from 'redux'
import user from './userReducer'
import articles from './articlesReducer'
import subscriptions from './subscriptionsReducer'

export default combineReducers({
    user,
    articles,
    subscriptions
});